import { render, staticRenderFns } from "./UserMenuButton.vue?vue&type=template&id=7f0a45ae&scoped=true"
import script from "./UserMenuButton.vue?vue&type=script&lang=ts"
export * from "./UserMenuButton.vue?vue&type=script&lang=ts"
import style0 from "./UserMenuButton.vue?vue&type=style&index=0&id=7f0a45ae&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0a45ae",
  null
  
)

export default component.exports